<template>
  <div class="">

    <template v-if="brokers == null"></template>

    <template v-else>

      <Filters v-bind:params="params"></Filters>

      <template v-if="brokers.length == 0">
        <div class="text-center mt-12">
          <img src="/static/img/icons/icons8-unfriend_male_filled.png" style="width:50px;" />

          <div class="mt-4 text-lg font-thin text-gray-700">
            No brokers found.
          </div>
        </div>
      </template>

      <template v-else>        
        <table class="bp-table">
          <thead>
            <tr class="border-b border-t">
              <th class="py-4 pl-6 pr-4 text-left border-r">
                Name

               <OrderByArrow
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="name"
                  orderKeyLabel="name"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow>
              </th>

              <th class="p-4 text-left border-r">
                Email

                <OrderByArrow
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="email"
                  orderKeyLabel="email"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow>
              </th>

              <th class="p-4 text-left border-r">
                Clients past month

                <OrderByArrow
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="recent_clients_count"
                  orderKeyLabel="# clients in the past month"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow>
              </th>

              <th class="p-4 text-left border-r">
                Registered

               <OrderByArrow
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="created_at"
                  orderKeyLabel="registered date"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow>
              </th>

              <th class="p-4 text-left border-r">
                Trial ends

                <OrderByArrow
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="trial_end_date"
                  orderKeyLabel="trial end date"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow>
              </th>

              <th class="p-4 text-left border-r">
                Paying?

                <OrderByArrow
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="paying"
                  orderKeyLabel="paying"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow>
              </th>

              <th class="p-4 text-left border-r">
                Referral

                <OrderByArrow
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="referrer_code"
                  orderKeyLabel="referred by"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow>
              </th>

              <th class="p-4 text-left border-r w-24">
                Source

                <OrderByArrow
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="source"
                  orderKeyLabel="source"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow>
              </th>

              <th class="p-4">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <BrokerListItem
              v-for="(broker, index) in brokers"
              v-bind:key="index"
              v-bind:broker="broker"
              v-bind:index="index">
            </BrokerListItem>
          </tbody>
        </table>

        <div class="p-4 overflow-hidden">
          <div class="float-left mr-12" style="margin-top:5px;">
            Found {{ this.numBrokers }} brokers
          </div>

          <template v-if="this.numBrokers > this.params.limit">
            <paginate
              :page-count="Math.ceil(this.numBrokers / this.params.limit)"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :prev-text="prev"
              :next-text="next"
              :click-handler="paginate">
            </paginate>
          </template>
        </div>

        <BrokerActions
          v-if="openBrokerActions"
          v-bind:broker="selectedBroker"></BrokerActions>
      </template>
    </template>
  </div>
</template>

<script>

  import axios          from "axios";
  import Paginate       from "vuejs-paginate";
  import Filters        from "./Filters"
  import BrokerListItem from "./BrokerListItem";
  import BrokerActions  from "./BrokerActions";
  import ContentLoader  from "@/shared/components/loaders/ContentLoader";
  import { EventBus }   from '@/shared/event-bus';
  import OrderByArrow   from '@/shared/components/OrderByArrow'


  export default {

    components: {
      Paginate,
      BrokerListItem,
      BrokerActions,
      ContentLoader,
      Filters,
      OrderByArrow
    },

    data() {
      return {
        brokers   : null,
        numBrokers: null,

        prev      : "Prev",
        next      : "Next",

        selectedBroker   : null,
        openBrokerActions: false,

        params : {}
      }
    },

    watch: {
      '$route' : {
        immediate: true,
        handler  : function(to, from) {
          if(Object.keys(to.params).length == 0) {
            this.resetParams()
          }

          else {
            this.setParams(to.params)
          }
          this.getBrokers()
        }
      }
    },

    mounted() {
      window.addEventListener('keyup', (event) => {
        if(event.keyCode == 27) {
          this.openBrokerActions = false
          this.selectedBroker    = null
        }
      });

      EventBus.$on('open-broker-actions', selectedBroker => {
        this.openBrokerActions = true;
        this.selectedBroker    = selectedBroker;
      });

      EventBus.$on('close-broker-actions', () => {
        this.openBrokerActions = false
        this.selectedBroker    = null
      });

      EventBus.$on('param-changed', keyValue => {
        this.params[keyValue.key] = keyValue.value
        this.$router.push({
          name   : 'broker-list-search',
          params : this.params
        });
      });

      EventBus.$on('reset-params', () => {
        this.resetParams()
        this.$router.push({
          name   : 'broker-list-search',
          params : this.params
        });
      });

      EventBus.$on('get-brokers', () => {
        this.getBrokers()
      });

      // if the event is triggered to grant/withdraw free access from broker
      EventBus.$on('toggle-free-access', broker => {
        this.toggleAccess(broker);
      });

      // if the event is triggered to suspend/unsuspend broker
      EventBus.$on('suspend-broker', broker => {
        this.suspendBroker(broker);
      });

      // if the event is triggered to termiate broker recent billing agreement
      EventBus.$on('terminate-billing', brokerId => {
        this.terminateBilling(brokerId);
      });

      // if the event is triggered to extend trial period of broker.
      EventBus.$on('extend-trial', data => {
        this.extendTrial(data);
      });
    },

    methods : {

      setParams(params) {

        // this is when we landed on the page and then clicked on
        // any search params to start a search
        if(params && Object.keys(params).length > 0) {
          this.params = params
        }

        // this is when we land directly on a particular search params
        else if(Object.keys(this.$route.params).length > 0) {
          this.params = this.$route.params
        }
      },

      resetParams() {
        this.params = {
          query     : this.$store.state.emptyQueryIndicator,
          orderBy   : "created_at",
          orderType : "desc",
          limit     : 50,
          offset    : 0
        }
      },

      getBrokers() {
        this.showLoader('Fetching brokers...')
        this.apiGet(this.params, 'broker/list', (data) => {
          this.hideLoader();
          this.brokers    = data.brokers
          this.numBrokers = data.total
        })
      },

      // whenever someone clicks on the table header, we will update the ordering
      // of the table
      // But what if we clicked on the same header that we are already ordering by?
      // in that case, we are simply swapping from either ascending to descending or
      // vice versa
      updateOrderBy(orderBy) {
        if(this.params.orderBy == orderBy) {
          this.params.orderType = this.params.orderType == 'asc' ? 'desc' : 'asc'
        } else {
          this.params.orderBy = orderBy
        }

        this.getBrokersAndUpdateRoute()
      },

      paginate(pageNum) {
        this.params.offset = this.params.limit * (pageNum-1)
        this.getBrokersAndUpdateRoute()
      },

      // each time the search parameter changes
      // we need to update the params on the store
      // and also update the route to reflect the changes
      // so that whenever user refreshes the URL, they are
      // landed on the same page
      getBrokersAndUpdateRoute() {
        // and let's refresh the route to reflect the new change
        this.$router.push({
          name   : 'broker-list-search',
          params : this.params
        });

        // let's re-fetch the brokers
        this.getBrokers()
      },

      toggleAccess: function (broker) {
        // get current value of broker access eligibility, i.e before the checkbox is toggled
        var currentValue = broker.free_access;
        
        // if current value is true, request is to remove the free access
        if (currentValue) {
           var msg = "Withdrawing free access from " + broker.first_name + ' ' + broker.last_name;
        } 

        else {
          // otherwise, request is to grant free access
          var msg = "Granting free access to " + broker.first_name + ' ' + broker.last_name;
        }
         
        this.openBrokerActions = false;
        this.showLoader(msg);
        // set action parameters to post to server.
        let params = { action: "free-access"};
        axios.post(process.env.VUE_APP_API_URL + '/api/broker/edit/' + broker.id, {
          // updated access must be the opposite of current value i.e if current value is 'true' to freeaccess, updated value must be 'false' to freeaccess.
          freeAccess: !currentValue
        }, {
          params,
          headers: {
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
          this.hideLoader();
          // update the broker data that is being used in BrokerActions component
          this.selectedBroker.free_access = !currentValue;
          this.selectedBroker.not_free_access = !!currentValue;
          // if broker is being granted of free access, remove suspended status from broker
          if (this.selectedBroker.free_access) {
            this.selectedBroker.suspended = false;
          }
          EventBus.$emit('notification-event', {
            'type'   : 'success',
            'message': 'Successfully updated!.'
          });
        }).catch(e => {
          this.openBrokerActions = false;
          this.hideLoader();
          EventBus.$emit('notification-event', {
            'type'   : 'error',
            'message': 'There is an error updating!.'
          });
        })
      },

      suspendBroker: function(broker) {
        this.openBrokerActions = false;
        var currentValue = broker.suspended;

        if (currentValue) {
          var msg = "Are you sure you want to un-suspend this broker?";
          var action = 'Un-suspending';
        } else {
          var msg = "Are you sure you want to suspend this broker?";
          var action = "Suspending";
        }

        // set action parameters to post to server.
        let params = { action: "suspended"};
        this.showLoader(action + " " + broker.first_name + ' ' + broker.last_name);
        axios.post(process.env.VUE_APP_API_URL + '/api/broker/edit/' + broker.id, {
          // updated access must be the opposite of current value i.e if current value is 'true' to freeaccess, updated value must be 'false' to freeaccess.
            suspended: !currentValue
        },
        {
          params,
          headers: {
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
        this.hideLoader();
         // update the broker data that is being used in BrokerActions component
        this.selectedBroker.suspended = !currentValue;
        // if broker is being suspended, then free access is being taken away from broker as well
        if (this.selectedBroker.suspended) {
          this.selectedBroker.free_access = false;
          this.selectedBroker.not_free_access = true;
        }
        EventBus.$emit('notification-event', {
          'type'   : 'success',
          'message': "Broker updated successfully."
        });

        }).catch(e => {
          this.hideLoader();
          EventBus.$emit('notification-event', {
            'type'   : 'error',
            'message': "There is an error updating broker."
          });
        })

      },

      extendTrial: function(data) {
        this.openBrokerActions = false;
        this.showLoader('Extending trial...')
        this.apiPost({
          duration: data.duration
        }, 'broker/extend-trial/' + data.brokerId, () => {
          this.hideLoader()
          this.getBrokers()
          EventBus.$emit('notification-event', {
            'type'   : 'success',
            'message': "Trial period extend successfully."
          })
        })
      },

      terminateBilling: function(brokerId) {
        this.openBrokerActions = false;
        let r = confirm("Terminate billing agreement?");
        if(r) {
          this.showLoader('Terminating billing agreement..')
          this.apiPost({}, 'broker/terminate-billing/' + brokerId, () => {
            this.hideLoader()
            this.getBrokers()
            EventBus.$emit('notification-event', {
              'type'   : 'success',
              'message': "Billing agreement was terminate successfully."
            })
          })
        }
      }
    }
  }
</script>
